$(document).on('click', '.eye-icon', function() {
  const $input = $(this).prev();
  $input.prop('type', $input.prop('type') === 'password' ? 'text' : 'password');
});
